<template>
  <footer class="site-footer" v-if="!isAdminRoute">
    <div class="footer-content">
      <div class="footer-links">
        <a 
          v-for="link in footerLinks" 
          :key="link.id"
          :href="link.url" 
          target="_blank" 
          rel="noopener"
        >{{ link.text }}</a>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const isAdminRoute = computed(() => route.path.startsWith('/admin'))
const footerLinks = ref([])

const fetchFooterLinks = async () => {
  try {
    const response = await fetch('/api/footer')
    if (response.ok) {
      const data = await response.json()
      footerLinks.value = data
    }
  } catch (error) {
    console.error('获取页脚链接失败:', error)
  }
}

onMounted(fetchFooterLinks)
</script>

<style scoped>
.site-footer {
  width: 100%;
  padding: 15px 0;
  background-color: #f5f5f5;
  text-align: center;
  margin-top: auto; /* 确保footer在内容不足时也在底部 */
}

.footer-content {
  font-size: 14px;
  color: #666;
}

.footer-links {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.footer-links a {
  color: #666;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: #333;
}
</style> 